import React, { FC, useMemo } from 'react'
import { PrintLayout } from 'components/Layout'
import { useSelector } from 'react-redux'
import { State } from 'index'
import { parseToDate } from 'lib/helper'
import { format } from 'date-fns'
import ja from 'date-fns/locale/ja'
import { PrintOrderTemplate } from 'components/Templates'
import { StockUnionType } from 'types/stock'
import { SortKey, SortOrder } from 'types/checkout'

const PrintOrder: FC = () => {
  const router = useSelector((state: State) => state.router)
  const pathname = router.location.pathname
  const { status, type } = router.location.query
  const sortKey = (router.location.query.sortKey as SortKey) || 'checkout_at'
  const sortOrder = (router.location.query.sortOrder as SortOrder) || 'desc'
  const date = /\/order\/print\/.+/.test(pathname) ? pathname.split('/order/print/')[1] : undefined
  const currentDate = date ? parseToDate(date) : new Date()
  const title = `${format(currentDate, 'M月d日(E)', { locale: ja })}のお渡し`
  const types = useMemo(() => (type?.split(',') as StockUnionType[]) || [], [type])
  return (
    <PrintLayout title={title}>
      <PrintOrderTemplate
        currentDate={currentDate}
        date={date}
        sortKey={sortKey}
        sortOrder={sortOrder}
        status={status}
        title={title}
        types={types}
      />
    </PrintLayout>
  )
}

export default PrintOrder
